// extracted by mini-css-extract-plugin
export var active = "_4o-7";
export var container = "_4o-0";
export var evenWidth = "_4o-4";
export var large = "_4o-5";
export var outlet = "_4o-8";
export var slide = "_4o-2";
export var small = "_4o-6";
export var tab = "_4o-3";
export var tabs = "_4o-1";